import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useRole } from './useRole';

export function useStudentAccess(studentId) {
  const { profile, isAdmin, loading: roleLoading } = useRole();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (roleLoading) return;
    if (!studentId) { setLoading(false); return; }

    // Owners and executives always have access
    if (isAdmin) {
      setHasAccess(true);
      setLoading(false);
      return;
    }

    if (!profile?.id) {
      setHasAccess(false);
      setLoading(false);
      return;
    }

    async function check() {
      const { data } = await supabase
        .from('student_subjects')
        .select('id, main_teacher_id, relief_teacher_ids')
        .eq('student_id', studentId);

      const enrollments = data || [];
      const canAccess = enrollments.some(
        e =>
          e.main_teacher_id === profile.id ||
          (Array.isArray(e.relief_teacher_ids) &&
            e.relief_teacher_ids.includes(profile.id))
      );

      setHasAccess(canAccess);
      setLoading(false);
    }

    check();
  }, [studentId, profile, isAdmin, roleLoading]);

  return { hasAccess, loading };
}